import React, { useState, useEffect } from "react";
import t from "../../../helpers/t";
import { useSelector } from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils"; // necessary to communicate with inbooma-react
import { moment, $ } from "../../../../../vendor";
import Editor from "rich-markdown-editor";
import Notification from "../../../components/Notification";
import FormItem from "../../../components/FormItem";
import ContingentNumbers from "./behaviors/ContingentNumbers";
import ProductsChange from "./behaviors/ProductsChange";
import LocationsChange from "./behaviors/LocationsChange";
import { in_array, setItem, getItem, _exchangeLabel } from "../../../../utils/Helper";
import ImageUpload from "../../../components/ImageUpload";
import Tooltip from "../../../components/Tooltip";

const ItemView = (props) => {
  const {
    dispatch,
    params,
    contingent,
    contingentsActions,
    resourcetypes,
    requestPath,
    showNotification,
    temp,
    setTemp,
    language,
  } = props;
  const saveState = useState(
    typeof contingent.id === "undefined"
      ? {
          // make a local copy of task or initialize a new task
          name: "",
          description: "",
          description_long: "",
          conditions: "",
          resourcetype_id: null,
          client_id: Biscuit.get("user.client_id"),
          fe_visible: true,
          locations: [],
          contingent_numbers: [{ number: 0, valid_from: moment().format("YYYY-MM-DD 00:00:00") }], // storing object descrition like order-number, resource name or user name
          products: [],
          resources: [],
          image: "",
        }
      : contingent,
  );
  const [contingentTemp, setContingentTemp] = useState(
    typeof contingent.id === "undefined"
      ? {
          // make a local copy of task or initialize a new task
          name: temp !== null ? temp.name : "",
          description: temp !== null ? temp.description : "",
          description_long: temp !== null ? temp.description_long : "",
          conditions: temp !== null ? temp.conditions : "",
          resourcetype_id: temp !== null ? temp.resourcetype_id : null,
          client_id: Biscuit.get("user.client_id"),
          fe_visible: temp !== null ? temp.fe_visible : true,
          locations: temp !== null ? temp.locations : [],
          contingent_numbers:
            temp !== null
              ? temp.contingent_numbers
              : [{ number: 0, valid_from: moment().format("YYYY-MM-DD 00:00:00") }], // storing object descrition like order-number, resource name or user name
          products: temp !== null ? temp.products : [],
          resources: temp !== null ? temp.resources : [],
          image: temp !== null ? temp.image : "",
        }
      : contingent,
  );

  const _addContingent = useSelector((state) => state.contingents_data.addContingent); // used for after save process
  const _editContingent = useSelector((state) => state.contingents_data.editContingent);
  const [contingentPending, setContingentPending] = useState(null); // holds the assigned user object (needs to be initialized)
  const [image, setImage] = useState(contingentTemp.image);
  const [doBulkResources, setDoBulkResources] = useState(typeof contingentTemp.id === "undefined");
  const [showDoBulkResources, setShowDoBulkResources] = useState(false);
  const [notification, setNotification] = useState({
    message: "",
    show: false,
  });

  useEffect(() => {
    if (
      contingentTemp.locations.length > 0 &&
      in_array(Number(contingentTemp.resourcetype_id), [1, 3, 5]) &&
      typeof contingentTemp.id === "undefined"
    ) {
      setShowDoBulkResources(true);
    } else {
      setShowDoBulkResources(false);
    }
  }, [contingentTemp]);

  useEffect(() => {
    if (image === "") return;
    let clone = {};
    Object.assign(clone, contingentTemp);
    clone.image = image;
    setContingentTemp(clone);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  useEffect(() => {
    if (_addContingent.success === "" || !contingentPending) {
      return;
    }
    if (_addContingent.success === true) {
      showNotification("success", _addContingent.id);
      setItem("contingent", "");
      close();
    } else {
      showNotification("warning", null, t(_addContingent.message));
    }
    setContingentPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_addContingent]);

  useEffect(() => {
    if (_editContingent.success === "" || !contingentPending) {
      return;
    }
    if (_editContingent.success === true) {
      showNotification("success", _editContingent.data.id);
      setItem("contingent", "");
      close();
    } else {
      showNotification("warning", null, t(_editContingent.data.message));
    }
    setContingentPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_editContingent]);

  const onSubmit = () => {
    if (
      doBulkResources &&
      contingentTemp.locations.length > 0 &&
      in_array(contingentTemp.resourcetype_id, [1, 3, 5])
    ) {
      autoGenerateResources();
    }
    let errmsg = t("Please enter the following fields: ");
    let errors = [];
    if (contingentTemp.name === "") {
      $(".contingent_name_input input").css("border-color", "red");
      errors.push(t("contingent_name", null, "capital"));
    }
    if (contingentTemp.resourcetype_id === null) {
      $(".resourcetype_select select").css("border-color", "red");
      errors.push(t("resourcetype", null, "capital"));
    }
    if (errors.length > 0) {
      showNotification("warning", null, errmsg + errors.join(", "));
      return;
    }
    const clone = {};
    Object.assign(clone, contingentTemp);
    clone.fe_visible = clone.fe_visible === 1 || clone.fe_visible === true ? 1 : 0;
    if (typeof contingentTemp.id === "undefined") {
      dispatch(
        contingentsActions.addContingent({
          token: Biscuit.get("token"),
          body: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setContingentPending(true);
    } else {
      if (clone.products.length > 0) {
        let products = [],
          productItems = [...clone.product_items];
        if (typeof clone.product_items !== "undefined") {
          clone.product_items.map((productItem) => {
            productItems.push(productItem.product_id);
          });
          clone.products.map((product) => {
            if (!in_array(product.id, productItems)) {
              productItems.push({
                foreign_key: clone.id,
                model: "Contingents",
                product_id: product.id,
              });
            }
            products.push(product.id);
          });
          productItems.map((prodItem, index) => {
            if (!in_array(prodItem.product_id, products)) {
              delete prodItem[index];
            }
          });
          products = [];
          clone.product_items = productItems;
        }
        clone.products.map((product) => {
          products.push({ id: product.id });
        });
        clone.products = products;
      }
      if (clone.resources.length > 0) {
        let resources = [];
        clone.resources.map((resource) => {
          if (typeof resource.id === "undefined") {
            resources.push(resource);
          }
        });
        clone.resources = resources;
      }
      if (clone.locations.length > 0) {
        let locations = [];
        clone.locations.map((location) => {
          locations.push({ id: location.id });
        });
        clone.locations = locations;
      }
      console.log("clone on Submit", clone);
      dispatch(
        contingentsActions.editContingent({
          token: Biscuit.get("token"),
          id: contingentTemp.id,
          body: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setContingentPending(true);
    }
  };

  const onChangeImage = (e) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    clone.image = e.target.value;
    console.log(clone);
    setContingentTemp(contingentTemp);
    setImage(e.target.value);
  };

  const onChangeBulk = (e) => {
    setDoBulkResources(e.target.checked);
  };

  const onChangeDescription = (value) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    clone.description = value()
      .replace(/^\s+|\s+$/g)
      .replace("undefined", "");
    if (clone.description.trimEnd().substr(clone.description.length - 1) === "\\") {
      clone.description = clone.description
        .trimEnd()
        .substr(0, clone.description.length - 1)
        .replace(/^\s+|\s+$/g)
        .replace("undefined", "");
    }
    setContingentTemp(clone);
  };
  const onChangeField = (e, name) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    if (name === "conditions") {
      if (e.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
        e = { target: { value: null } };
      } else {
        let temp = e;
        e = { target: { value: temp } };
      }
    }
    if (name === "description_long") {
      if (e.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
        e = { target: { value: null } };
      } else {
        let temp = e;
        e = { target: { value: temp } };
      }
    }
    clone[name] = in_array(name, ["fe_visible"]) ? e.target.checked : e.target.value;

    if (name === "name" && e.target.value !== "") {
      $(".contingent_name_input input").css("border-color", "rgb(227, 227, 227)");
    }

    setContingentTemp(clone);
  };
  const autoGenerateResources = () => {
    let autoGenerateNumber = 0;
    contingentTemp.contingent_numbers.map((cn) => {
      if (autoGenerateNumber < cn.number) {
        autoGenerateNumber = cn.number;
      }
    });
    if (contingentTemp.resources.length > 0) {
      if (contingentTemp.resources.length >= autoGenerateNumber) {
        return;
      }
      autoGenerateNumber -= contingentTemp.resources.length;
    }
    if (autoGenerateNumber >= 1) {
      // Auto-generate resources
      let clone = {};
      Object.assign(clone, contingentTemp);
      for (var i = 0; i < autoGenerateNumber; i++) {
        let res = {
          status: "active",
          location_id: contingentTemp.locations[0].id,
          client_id: Number(Biscuit.get("user.client_id")),
        };
        clone.resources.push(res);
      }
      setContingentTemp(clone);
    }
  };

  const onChangeResourcetype = (e) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    if (e.target.value !== null) {
      $(".resourcetype_select select").css("border-color", "rgb(227, 227, 227)");
    }
    clone.resourcetype_id = e.target.value;
    setContingentTemp(clone);
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      show: false,
    });
  };
  const currentUrl = new URL(window.location.href);
  const close = () => {
    let changes = false;
    for (const [value] of Object.entries(saveState)) {
      for (const [k, v] of Object.entries(value)) {
        if (v !== contingentTemp[k]) {
          changes = true;
        }
      }
    }
    changes = false;
    let bestaetigung =
      getItem("contingent") === "" && !changes
        ? true
        : window.confirm(
            "Es gibt ungespeicherte Daten, soll das Formular dennoch geschlossen werden?",
          );
    if (bestaetigung) {
      dispatch(contingentsActions.getContingentResetData());
      dispatch(contingentsActions.getContingentsResetData());
      setItem("contingent", "");
      let returnUrl =
        typeof requestPath !== "undefined"
          ? requestPath + currentUrl.search
          : `/contingents${currentUrl.search}`;
      window.location.replace(returnUrl);
    }
  };

  const onProductChange = (products) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    clone.products = products;
    setContingentTemp(clone);
  };

  const onLocationChange = (locations) => {
    let clone = {};
    Object.assign(clone, contingentTemp);
    clone.locations = locations;
    setContingentTemp(clone);
  };

  const abortButtonRef = React.createRef();

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"> </div>
      {notification.show && (
        <>
          <Notification message={notification.message} close={closeNotification}></Notification>
        </>
      )}
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {contingent !== null && contingent.id !== undefined && contingent.id !== ""
              ? t("edit_${a}", { a: t("contingent") })
              : t("add_${a}", { a: t("contingent") })}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={onSubmit}
            >
              {!contingentPending && (
                <>
                  <i className="fi fi-check"> </i>
                  <span>{t("save")}</span>
                </>
              )}
              {contingentPending && (
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader"
                    src={"assets/img/rolling_loader.svg"}
                  />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-tasksform-abort-button"
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => close()}
              >
                <i className="fi fi-x"> </i>
              </button>
            </a>
          </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof contingentTemp.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(contingentTemp.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              contingentTemp.created_by_name +
              " | " +
              t("last_modified_at") +
              " " +
              moment(contingentTemp.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              contingentTemp.modified_by_name}
        </p>
        <form className="off-content row">
          <FormItem
            name="name"
            inputType="text"
            id={
              "contingents_name_" +
              (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
            }
            label={t("contingent_name", null, "capital")}
            type="input"
            value={contingentTemp.name}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            extraTopClasses="contingent_name_input"
          />
          {/* <FormItem
                    name="description"
                    inputType="text"
                    id={"contingents_description_"+(typeof contingentTemp.id !== 'undefined'?contingentTemp.id:'new')}
                    label={t('description',null,'capital')}
                    type="input"
                    value={contingentTemp.description}
                    mediumWidth={6}
                    smallWidth={6}
                    onChangeHandler={onChangeField}
                    labelStyle={{width:"100%"}}
                    inputStyle={{width:"100%"}}
                    disabled={Biscuit.get('user.role') === 'manager'?'disabled':''}
                    notTiny={true}
                    extraTopClasses=""/>*/}
          <div className={"list-item-block-offcanvas medium-6 small-6 column "}>
            <div className="inb-form-group column label-float-left medium-12 small-12">
              <label className="inb-form__controlLabel" style={{ width: "100%" }}>
                {t("description", null, "capital")}
              </label>
              <div
                className={"inb-form__controllClass"}
                style={{ width: "100%", maxWidth: "100%" }}
              >
                {Biscuit.get("user.role") !== "manager" ? (
                  <div style={{ border: "1px solid #e3e3e3" }}>
                    <Tooltip
                      tooltip={t("notification_for_markdown")}
                      placement={"bottom"}
                      children={
                        <Editor
                          defaultValue={contingentTemp.description}
                          onChange={onChangeDescription}
                          placeholder=""
                        />
                      }
                    />
                  </div>
                ) : (
                  <span>{contingentTemp.description}</span>
                )}
              </div>
            </div>
          </div>
          <FormItem
            name="description_long"
            type="editor"
            id={
              "contingents_description_long_" +
              (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
            }
            label={t("description long", null, "capital")}
            value={contingentTemp.description_long}
            mediumWidth={12}
            smallWidth={12}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            extraTopClasses=""
          />
          {Biscuit.get("client.showRightOfWithdrawalFields") == "true" && (
            <FormItem
              name="conditions"
              type="editor"
              id={
                "contingents_conditions_" +
                (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
              }
              label={t(_exchangeLabel("conditions"))}
              value={contingentTemp.conditions}
              mediumWidth={12}
              smallWidth={12}
              onChangeHandler={onChangeField}
              labelStyle={{ width: "100%" }}
              disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
              extraTopClasses=""
            />
          )}
          <ImageUpload
            onChange={onChangeImage}
            image={image}
            type="contingent"
            clientId={Biscuit.get("user.client_id")}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            setImage={setImage}
            dispatch={dispatch}
          />
          <FormItem
            name="resourcetype_id"
            inputType="select"
            id={
              "contingents_resourcetype_id_" +
              (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
            }
            label={t("resourcetype", null, "capital")}
            type="select"
            dataKey="id"
            data={resourcetypes}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            selected={contingentTemp.resourcetype_id !== null ? contingentTemp.resourcetype_id : ""}
            mediumWidth={6}
            smallWidth={12}
            onChangeHandler={onChangeResourcetype}
            placeholder={t("please_select")}
            extraTopClasses="resourcetype_select"
          />
          <LocationsChange
            params={params}
            contingent={contingentTemp}
            setContingent={setContingentTemp}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            dispatch={dispatch}
            setTemp={setTemp}
            onChange={onLocationChange}
          />
          {in_array(contingentTemp.resourcetype_id, [1, 3, 5]) && (
            <FormItem
              name="count_resources_bookable_at_same_time"
              type="input"
              inputType="number"
              inputStyle={{ maxWidth: "80px", clear: "both" }}
              id={
                "contingents_count_resources_bookable_at_same_time_" +
                (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
              }
              label={t("count_resources_bookable_at_same_time", null, "capital")}
              labelStyle={{}}
              htmlFor={""}
              value={contingentTemp.count_resources_bookable_at_same_time}
              mediumWidth={6}
              smallWidth={12}
              min={1}
              disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
              onChangeHandler={onChangeField}
              extraTopClasses=""
            />
          )}
          <FormItem
            name="fe_visible"
            type="checkbox"
            id={
              "contingents_fe_visible_" +
              (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
            }
            label={t("fe_visible", null, "capital")}
            labelStyle={{}}
            htmlFor={""}
            value={contingentTemp.fe_visible}
            mediumWidth={6}
            smallWidth={12}
            switchStyle={{ clear: "both" }}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            onChangeHandler={onChangeField}
            extraTopClasses=""
          />
          {showDoBulkResources && (
            <FormItem
              name="do_bulk_action"
              type="checkbox"
              id={
                "contingents_do_bulk_action_" +
                (typeof contingentTemp.id !== "undefined" ? contingentTemp.id : "new")
              }
              label={t("autogenerate_resources", null, "capital")}
              labelStyle={{}}
              htmlFor={""}
              value={doBulkResources}
              mediumWidth={6}
              smallWidth={12}
              switchStyle={{ clear: "both" }}
              disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
              onChangeHandler={onChangeBulk}
              helpText={t("autogenerate_resources_body")}
              extraTopClasses=""
            />
          )}
          <ProductsChange
            params={params}
            contingent={contingentTemp}
            setContingent={setContingentTemp}
            dispatch={dispatch}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            setTemp={setTemp}
            onChange={onProductChange}
            showNotification={showNotification}
          />
          <ContingentNumbers
            contingent={contingentTemp}
            existingDisabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            setContingent={setContingentTemp}
          />
        </form>
      </div>
    </>
  );
};

export default ItemView;
